import React from 'react';
import useDuplicateImagesStore from './useDuplicateImagesStore';

interface PrimaryImageToggleProps {
  imageId: number;
}

const PrimaryImageToggle = ({ imageId }: PrimaryImageToggleProps) => {
  const setPrimaryImage = useDuplicateImagesStore(state => state.setPrimaryImage);
  const isPrimaryImage = useDuplicateImagesStore(state => state.isPrimaryImage);

  const inputId = `useAsPrimary-${imageId}`;
  const label = 'Use as primary image';

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setPrimaryImage(imageId);
    }
  };

  return (
    <label
      className="tw-cursor-pointer tw-w-full tw-h-full"
      htmlFor={inputId}
    >
      <input
        aria-label={`${label} (Image ID: ${imageId})`}
        checked={isPrimaryImage(imageId)}
        className="tw-w-4 tw-h-4 tw-cursor-pointer"
        id={inputId}
        tabIndex={0}
        type="radio"
        onChange={() => setPrimaryImage(imageId)}
        onKeyDown={handleKeyDown}
      />
      <span className="sr-only">{label}</span>
    </label>
  );
};

export default PrimaryImageToggle;
